/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Opacity_LabelInputs */

const en_styles_opacity_label = /** @type {(inputs: Styles_Opacity_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opacity`)
};

const fr_styles_opacity_label = /** @type {(inputs: Styles_Opacity_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opacite`)
};

const de_styles_opacity_label = /** @type {(inputs: Styles_Opacity_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opazität`)
};

const it_styles_opacity_label = /** @type {(inputs: Styles_Opacity_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opacità`)
};

const ru_styles_opacity_label = /** @type {(inputs: Styles_Opacity_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Непрозрачность`)
};

const es_styles_opacity_label = /** @type {(inputs: Styles_Opacity_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opacidad`)
};

const zh_cn2_styles_opacity_label = /** @type {(inputs: Styles_Opacity_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不透明度`)
};

const ja_styles_opacity_label = /** @type {(inputs: Styles_Opacity_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不透明度`)
};

const hi_styles_opacity_label = /** @type {(inputs: Styles_Opacity_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अस्पष्टता`)
};

const pt_pt2_styles_opacity_label = /** @type {(inputs: Styles_Opacity_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opacidade`)
};

/**
* | output |
* | --- |
* | "Opacity" |
*
* @param {Styles_Opacity_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_opacity_label = /** @type {((inputs?: Styles_Opacity_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Opacity_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_styles_opacity_label(inputs)
	if (locale === "de") return de_styles_opacity_label(inputs)
	if (locale === "it") return it_styles_opacity_label(inputs)
	if (locale === "ru") return ru_styles_opacity_label(inputs)
	if (locale === "es") return es_styles_opacity_label(inputs)
	if (locale === "zh-CN") return zh_cn2_styles_opacity_label(inputs)
	if (locale === "ja") return ja_styles_opacity_label(inputs)
	if (locale === "hi") return hi_styles_opacity_label(inputs)
	if (locale === "pt-PT") return pt_pt2_styles_opacity_label(inputs)
	return en_styles_opacity_label(inputs)
});